import {useMutation} from '@tanstack/react-query';
import {useClient} from 'context/auth-context';

const useSubscriptionSession = () => {
    const client = useClient();

    return useMutation<
        any,
        unknown,
        {businessPartner: string; priceId: string | null}
    >({
        mutationFn: data =>
            client('/web_api/subscription-sessions', {
                data,
                method: 'POST',
            }),
    });
};

export {useSubscriptionSession};
